export var RoleHistoryLogEnum;
(function (RoleHistoryLogEnum) {
    RoleHistoryLogEnum["remote_user"] = "remote user";
    RoleHistoryLogEnum["workshop_user"] = "workshop user";
    RoleHistoryLogEnum["bdeo_user"] = "bdeo-user";
    RoleHistoryLogEnum["system"] = "system";
})(RoleHistoryLogEnum || (RoleHistoryLogEnum = {}));
